import { useEffect } from 'react';

import { useFeatureFlagBase } from '../../hooks/use-feature-flag-base';

const win = window as any;

const OPEN_FORSTA_FORM = () => {
  win?.doConfirmitFeedbackSurvey();
};

declare global {
  interface Window {
    openFeedbackForm: () => void;
  }
}

/**
 * This hook is used to render the form when user clicks "Give Feedback"
 * in the sidebar help menu. If the user is a whitelisted for Forsta, the Forsta feedback form
 * will be displayed.
 */
export function useFeedbackFormRouter() {
  const { boValues: value, isReady } = useFeatureFlagBase();
  const shouldShowForstaFeedback =
    isReady && value['FORSTA_Feedback_Form_WhitelistedResellers'] === 'true';

  useEffect(() => {
    window.openFeedbackForm = shouldShowForstaFeedback && OPEN_FORSTA_FORM;
  }, [shouldShowForstaFeedback]);
}
